import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAppSelector } from '../../../app/hooks';
import { FeatureFlags } from '../constants';
import {
  selectDisableDeveloper,
  selectDisableDiagnostics,
} from '../featureFlagSlice';

type UseFeatureFlagsReturn = FeatureFlags;

/**
 * Get the feature flags.
 *
 * @param raw if true, returns the feature flags exactly as they are in LaunchDarkly.
 * Otherwise, returns the feature flags with any local overrides applied.
 *
 * @returns The feature flags.
 */
const useFeatureFlags = (raw: boolean = false): UseFeatureFlagsReturn => {
  const featureFlags = useFlags<FeatureFlags>();

  const disableDiagnostics = useAppSelector(selectDisableDiagnostics);
  const disableDeveloper = useAppSelector(selectDisableDeveloper);
  if (raw) {
    return featureFlags;
  }

  return {
    ...featureFlags,
    Diagnostics: disableDiagnostics ? false : featureFlags.Diagnostics,
    Developer: disableDeveloper ? false : featureFlags.Developer,
  };
};

export { useFeatureFlags };
